/* global axios */
import ApiClient from './ApiClient';

class FacebookOAuthClient extends ApiClient {
  constructor() {
    super('facebook', { accountScoped: true });
  }

  // Devolve a URL do diálogo OAuth da Meta para onde o navegador deve ir.
  generateAuthorization() {
    return axios.post(`${this.url}/authorization`);
  }

  // `fbSession` é a chave opaca devolvida pelo callback. O token do usuário fica
  // no servidor; o frontend nunca o vê.
  listPages(fbSession) {
    return axios.get(`${this.url}/pages`, {
      params: { fb_session: fbSession },
    });
  }

  connectPage({ fbSession, pageId, inboxName }) {
    return axios.post(`${this.url}/pages`, {
      fb_session: fbSession,
      page_id: pageId,
      inbox_name: inboxName,
    });
  }

  disconnectPage(pageId) {
    return axios.delete(`${this.url}/pages/${pageId}`);
  }
}

export default new FacebookOAuthClient();
